<template>
    <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Hero icons/heroicons-outline/information-circle">
            <path
                id="Vector"
                d="M9.375 9.875L9.40957 9.85771C9.88717 9.61891 10.4249 10.0503 10.2954 10.5683L9.70458 12.9317C9.57507 13.4497 10.1128 13.8811 10.5904 13.6423L10.625 13.625M17.5 10.5C17.5 14.6421 14.1421 18 10 18C5.85786 18 2.5 14.6421 2.5 10.5C2.5 6.35786 5.85786 3 10 3C14.1421 3 17.5 6.35786 17.5 10.5ZM10 7.375H10.0063V7.38125H10V7.375Z"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="stroke-current"
            />
        </g>
    </svg>
</template>
